<script>
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker, radio } from 'vue-strap';
  
  export default {
    components: { datepicker, radio },
    props: {
      solicitacao: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        
      }
    },
    computed: {
      apenasIda() {
        return this.solicitacao.apenasIda === 'true';
      }
    },
    methods: {
      validar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        return this.$validator.validateAll();
      },
      limparDadosVolta() {
        if (this.apenasIda) {
          this.solicitacao.origemVolta = null;
          this.solicitacao.destinoVolta = null;
          this.solicitacao.dataVolta = '';
          this.solicitacao.horarioVolta = null;
          this.solicitacao.horarioChegadaVolta = null;
          this.solicitacao.quantidadePassagemVolta = null;
          this.solicitacao.valorPassagemVolta = null;
          this.solicitacao.idTipoPassagemVolta = null;
        }
      },
      apenasIdaAlterado() {
        this.$emit('apenasIdaAlterado', this.apenasIda);
      },
    },
    mounted() {
      this.$nextTick(() => {
        $('.radios .radio')
          .css('display', 'inline')
          .eq(0).css('margin-right', '10px');

        //$('.datepicker input').attr('readonly', '');
      });
    },
    watch: {
      'apenasIda': 'limparDadosVolta',
      'apenasIda': 'apenasIdaAlterado',
    }
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group radios">
          <radio
            v-model="solicitacao.apenasIda"
            selected-value="false"
            type="success">
            Ida e volta
          </radio>

          <radio
            v-model="solicitacao.apenasIda"
            selected-value="true"
            type="success">
            Apenas ida
          </radio>
        </div>
      </div>
    </div>
    
    <h3 class="m-t-none m-b">Ida</h3>
    <div class="hr-line-dashed margin-top-5"></div>
    
    <div class="row">
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('origemIda')}">
          <label class="control-label">Origem</label>

          <input
            class="form-control"
            type="text"
            v-model="solicitacao.origemIda"
            data-vv-name="origemIda"
            data-vv-as="origem"
            v-validate="'required'"
            maxlength="100">

          <p class="text-danger" v-show="errors.has('origemIda')">{{ errors.first('origemIda') }}</p>
        </div>
      </div>
      
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('destinoIda')}">
          <label class="control-label">Destino</label>

          <input
            class="form-control"
            type="text"
            v-model="solicitacao.destinoIda"
            data-vv-name="destinoIda"
            data-vv-as="destino"
            v-validate="'required'"
            maxlength="100">

          <p class="text-danger" v-show="errors.has('destinoIda')">{{ errors.first('destinoIda') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('dataIda')}">
          <label class="control-label">Data</label>

          <datepicker id="dataIda"
                      v-mascara="'data-mask'"
                      v-model="solicitacao.dataIda"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataIda"
                      data-vv-as="data ida"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataIda')">{{ errors.first('dataIda') }}</p>
        </div>
      </div>
      
      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('horarioIda')}">
          <label class="control-label">Horário de saída</label>

          <input
            id="horario-saida-ida"
            class="form-control"
            type="text"
            v-mascara="'hora'"
            v-model="solicitacao.horarioIda"
            data-vv-name="horarioIda"
            data-vv-as="horário de saída"
            v-validate="'required|date_format:HH:mm'">

          <p class="text-danger" v-show="errors.has('horarioIda')">{{ errors.first('horarioIda') }}</p>
        </div>
      </div>
      
      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('horarioChegadaIda')}">
          <label class="control-label">Horário de chegada</label>

          <input
            id="horario-chegada-ida"
            class="form-control"
            type="text"
            v-mascara="'hora'"
            v-model="solicitacao.horarioChegadaIda"
            data-vv-name="horarioChegadaIda"
            data-vv-as="horário de chegada"
            v-validate="'required'">

          <p class="text-danger" v-show="errors.has('horarioChegadaIda')">{{ errors.first('horarioChegadaIda') }}</p>
        </div>
      </div>
    </div>

    <div v-show="!apenasIda">
      <h3 class="m-t-none m-b">Volta</h3>
      <div class="hr-line-dashed margin-top-5"></div>

      <div class="row">
        <div class="col-lg-3">
          <div class="form-group required" :class="{'has-error': errors.has('origemVolta')}">
            <label class="control-label">Origem</label>

            <input
              class="form-control"
              type="text"
              v-model="solicitacao.origemVolta"
              data-vv-name="origemVolta"
              data-vv-as="origem"
              v-validate="!apenasIda ? 'required' : ''"
              maxlength="100">

            <p class="text-danger" v-show="errors.has('origemVolta')">{{ errors.first('origemVolta') }}</p>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="form-group required" :class="{'has-error': errors.has('destinoVolta')}">
            <label class="control-label">Destino</label>

            <input
              class="form-control"
              type="text"
              v-model="solicitacao.destinoVolta"
              data-vv-name="destinoVolta"
              data-vv-as="destino"
              v-validate="!apenasIda ? 'required' : ''"
              maxlength="100">

            <p class="text-danger" v-show="errors.has('destinoVolta')">{{ errors.first('destinoVolta') }}</p>
          </div>
        </div>

        <div class="col-lg-2">
          <div class="form-group required" :class="{'has-error': errors.has('dataVolta')}">
            <label class="control-label">Data</label>

            <datepicker id="dataVolta"
                        v-mascara="'data-mask'"
                        v-model="solicitacao.dataVolta"
                        format="dd/MM/yyyy"
                        placeholder="  /  /     "
                        lang="pt-BR"
                        data-vv-name="dataVolta"
                        data-vv-as="data volta"
                        v-validate="!apenasIda ? 'required|date_format:DD/MM/YYYY' : ''">
            </datepicker>

            <p class="text-danger" v-show="errors.has('dataVolta')">{{ errors.first('dataVolta') }}</p>
          </div>
        </div>

        <div class="col-lg-2">
          <div class="form-group required" :class="{'has-error': errors.has('horarioVolta')}">
            <label class="control-label">Horário de saída</label>

            <input
              id="horario-saida-volta"
              class="form-control"
              type="text"
              v-mascara="'hora'"
              v-model="solicitacao.horarioVolta"
              data-vv-name="horarioVolta"
              data-vv-as="horário de saída"
              v-validate="!apenasIda ? 'required|date_format:HH:mm' : ''">

            <p class="text-danger" v-show="errors.has('horarioVolta')">{{ errors.first('horarioVolta') }}</p>
          </div>
        </div>

        <div class="col-lg-2">
          <div class="form-group required" :class="{'has-error': errors.has('horarioChegadaVolta')}">
            <label class="control-label">Horário de chegada</label>

            <input
              id="horario-chegada-volta"
              class="form-control"
              type="text"
              v-mascara="'hora'"
              v-model="solicitacao.horarioChegadaVolta"
              data-vv-name="horarioChegadaVolta"
              data-vv-as="horário de chegada"
              v-validate="!apenasIda ? 'required' : ''">

            <p class="text-danger" v-show="errors.has('horarioChegadaVolta')">{{ errors.first('horarioChegadaVolta') }}</p>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row" style="height:300px;">
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso/componentes/compartilhado/FormDadosViagem.vue